import _ from "lodash";

/**
 * Recursively converts all snake_case keys to camelCase
 * Handles nested objects, arrays, and preserves special types (Date, Function)
 *
 * @param {*} obj - Object, array, or primitive value to convert
 * @returns {*} New object with camelCase keys (or original value if not an object)
 */
export function deepCamelizeKeys(obj) {
  if (_.isArray(obj)) {
    return obj.map(deepCamelizeKeys);
  }

  if (_.isObject(obj) && !_.isDate(obj) && !_.isFunction(obj)) {
    return _.transform(
      obj,
      (result, value, key) => {
        // eslint-disable-next-line no-param-reassign
        result[_.camelCase(key)] = deepCamelizeKeys(value);
      },
      {},
    );
  }

  return obj;
}

/**
 * Recursively converts all camelCase keys to snake_case
 * Handles nested objects, arrays, and preserves special types (Date, Function)
 *
 * @param {*} obj - Object, array, or primitive value to convert
 * @returns {*} New object with snake_case keys (or original value if not an object)
 */
export function deepSnakeKeys(obj) {
  if (_.isArray(obj)) {
    return obj.map(deepSnakeKeys);
  }

  if (_.isObject(obj) && !_.isDate(obj) && !_.isFunction(obj)) {
    return _.transform(
      obj,
      (result, value, key) => {
        // eslint-disable-next-line no-param-reassign
        result[_.snakeCase(key)] = deepSnakeKeys(value);
      },
      {},
    );
  }

  return obj;
}

export default { deepCamelizeKeys, deepSnakeKeys };
